import auth from './auth.json';
import sidebar from './sidebar.json';
import channel from './channel.json';
import tabs from './tabs.json';
import common from './common.json';
import sortControls from './sortControls.json';
import filterButtons from './filterButtons.json';
import channelModal from './channelModal.json';
import UI from './UI.json';
import addPostcardModal from './addPostcardModal.json';
import categories from './categories.json';
import navigation from './navigation.json';
import resources from './resources.json';

export default {
    auth,
    sidebar,
    channel,
    tabs,
    common,
    sortControls,
    filterButtons,
    channelModal,
    UI,
    addPostcardModal,
    categories,
    navigation,
    resources
}; 